@file:Suppress("MagicNumber")

package com.nonopn.skydome.common.app.pages.main.model.api

import com.nonopn.skydome.common.app.detection.ThunderDetection
import com.nonopn.skywatcher.maps.LatLng
import com.nonopn.skywatcher.maps.MapUtils
import korlibs.time.DateTime
import korlibs.time.DateTimeTz
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ThunderDetectionActivity(
    val externalId: String = "",
    val latitude: Double = 0.0,
    val longitude: Double = 0.0,
    @SerialName("recTimestamp")
    val recTimestampSeconds: Long = 0L,
    val recISO: String = "",
    val pulseType: PulseType = PulseType.IC,
    val pulsePeakAmp: Int = 0,
    val pulseNumSensors: Int = 0,
    val ellipseSemiMajorMeter: Int = 0,
    val ellipseSemiMinorMeter: Int = 0,
    val ellipseAngleDegree: Int = 0,
    val strokeCount: Int? = null
) {
    val ellipseSemiMinorMeterOrDefault: Int
        get() = if (ellipseSemiMinorMeter > 0) {
            ellipseSemiMinorMeter
        } else {
            1000
        }

    val ellipseSemiMajorMeterOrDefault: Int
        get() = if (ellipseSemiMajorMeter > 0) {
            ellipseSemiMajorMeter
        } else {
            1500
        }

    val recDateTime: DateTimeTz
        get() = DateTime.fromUnixMillis(recTimestampSeconds * 1000).local

    val coordinates: LatLng = LatLng(latitude, longitude)

    fun activityAge(selectedDate: DateTimeTz = DateTimeTz.nowLocal()): ActivityAge {
        val now = selectedDate.utc.unixMillisLong / 1000
        val diff = now - recTimestampSeconds

        if (diff < 0) return ActivityAge.Recent

        return when {
            diff < 5 * 60 -> ActivityAge.Recent
            diff < 10 * 60 -> ActivityAge.Moderate
            diff < 20 * 60 -> ActivityAge.Old
            else -> ActivityAge.VeryOld
        }
    }

    fun distance(detection: ThunderDetection) = MapUtils.distance(
        detection.latitude,
        detection.longitude,
        latitude,
        longitude
    )

    fun distance(distance: LatLng) = MapUtils.distance(
        distance.latitude,
        distance.longitude,
        latitude,
        longitude
    )
}
